module.exports = __webpack_public_path__ + "media/images/2_clevas_regist_user_active-d5847167.png";